import { fork, all } from "redux-saga/effects";
import { default as users } from "../store/ducks/users";
import { default as providers } from "../store/ducks/providers";
import { default as stores } from "../store/ducks/stores";
import { default as config } from "../store/ducks/config";
export default function* rootSaga() {
  yield all([fork(users), fork(providers), fork(stores), fork(config)]);
}
